import { render, staticRenderFns } from "./DealerList.vue?vue&type=template&id=329d42f1&scoped=true"
import script from "./DealerList.vue?vue&type=script&lang=js"
export * from "./DealerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d42f1",
  null
  
)

export default component.exports